import $ from "jquery";
import { contentMeta, createGuid } from "./general_functions";
import language from "./translation";

import { getImageByContentId, getImage } from "./images";
import breadcrumb from '../templates/pages/breadcrumb';

export const setNews = (news) => {

    let newsList = [];

    $.each(news.listOfContent, function(a, b) {

        let date = new Date(b.modified);

        let pDate = ('0' + date.getDate()).slice(-2) + '.' +
            ('0' + (date.getMonth() + 1)).slice(-2) + '.' +
            date.getFullYear();

        newsList.push(`
                <div class="newslist__item__frontpage">
                    <h3 class="newslist__header">
                        <a href="/article/${b.contentId}" class="newslist__link"><span>${b.title}</span></a>
                    </h3>
                    <p class="newslist__intro">${b.intro}</p>
                    <div class="newslist__date text-right">${pDate}</div>
                </div>`);

    });

    newsList = newsList.join("");

    return newsList;

};

export const getNews = (num = 3, from = 0, callback) => {

    let clientid = client.clientId;
    
    let tempdown = false;
    
    const ga = $.getJSON(window.apiUrl + `/api/PublicContentApi/getcontentlistdescending/${clientid}/mal_nyhet${tempdown ? "_" : ""}/${num}/${from}/Modified`).done((result) => {

        if(!tempdown){
            callback(result);
        }
        else {
            $("#news,.newslist__list").html("Nyhetsvisningen er midlertidig nede. Vi jobber med å få tjensten på plass igjen.");
        }

    });

};

export const setFrontNews = (num = 3) => {

    getNews(num, 0, function(result) {

        let news = setNews(result);

        $("#news").html(news);

        if (result.totalCount > num) {
            $("#news").append(`
            <div class="news__summary text-right">
                <a href="/liste/nyheter" class="newslist__seeall">${language("NEWS_SEEALL")}</a>
            </div>
            `);
        }

    });


};

export const setNewsList = (from, loadNum) => {

    const breadcrumbHtml = breadcrumb();

    loadNum = loadNum || 10;
    from = from || 0;

    getNews(loadNum, from, function(result) {
        
        // console.log("News", result);

        // if (result.totalCount > loadNum) {
        //     console.log("spose need More than 25");
        // }

        let availablenews = result.totalCount;
        let to = loadNum + from;

        let newsList = [];

        $.each(result.listOfContent, function(a, b) {

            let date = new Date(b.firstCreated);
            


            let pDate = ('0' + date.getDate()).slice(-2) + '-' +
                ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
                date.getFullYear();

            let meta = contentMeta(b);

            // console.log("meta", meta);

            let img = "";
            let width = "col-sm-9";

            if (meta.imageContentId !== undefined && meta.imageContentId.length > 0) {
                let imgId = createGuid();
                img = `
                    <div class="col-sm-3 image__container">
                        <img src="" alt="" class="article__introimage" id="${imgId}" >
                    </div>`;

                //console.log('getImageByContentId: + ' + meta.imageContentId);
                getImageByContentId(meta.imageContentId, (img) => {
                    if (img.url !== undefined && img.url.length > 0) {
                        $(`#${imgId}`).attr("src", img.url);
                    }
                });
            }

            newsList.push(`
                <div class="newslist__item">
                    <div class="row">
                        ${img}
                        <div class="${width}">
                            <div class="newslist__content">
                                <h3 class="newslist__header">
                                    <a href="/article/${b.contentId}" class="newslist__link">${b.title}</a>
                                </h3>
                                <p class="newslist__intro">${b.intro}</p>
                                <div class="newslist__date">${pDate}</div>
                            </div>
                        </div>
                    </div>
                </div>`);
        });

        $("#currentPageBreadcrumb").text(document.title);
        newsList = newsList.join("");

        $(".newslist__list").append(newsList);
        
        
        const newslist__header = `
            <div class="row">
                <div class="col mt-5">
                    <p>
                        ${language("NEWS_PAGEIN_1")} ${(from+1)} ${language("NEWS_PAGEIN_2")} ${availablenews > to ? to : availablenews} ${language("NEWS_PAGEIN_3")} ${availablenews}
                    </p>
                </div>
            </div>
        
        `;

        $(".newslist__info").html(newslist__header);
        
        if(availablenews > loadNum){
            
            let pages = Math.ceil(availablenews / loadNum);
            
            // console.log(pages);
            
            let pageslinks = [];
            let i = 0;
            
            for(i=0; i< pages; i++){
             
                pageslinks.push(`
                    <li class="page-item ${(i*loadNum) === from ? "disabled" : ""}"><a class="page-link news__page__links " href="#" data-from="${(i*loadNum)}" >${(i+1)}</a></li>`);   
                
            }
            
            pageslinks = pageslinks.join("");
            
            const newslist__footer = `
            
            <div class="row">
                <div class="col mt-5">
                
                    <nav aria-label="${language("NEWS_BROWSEPAGES")}">
                      <ul class="pagination  pagination-lg">
                        ${pageslinks}
                      </ul>
                    </nav>
                    
                </div>
            </div>
            
            `;
            
            $(".newslist__footer").html(newslist__footer);
        }

    });
    
    $("body").off("click",".news__page__links");
    
    $("body").on("click", ".news__page__links", function(e){
        e.preventDefault();
        const num = $(this).data("from");
        setNewsList(parseInt(num));
        // $(window).scrollTo(0);
    });
    

    $("#maincontent").html(`
        <div class="container">
            ${breadcrumbHtml}
        </div>
        <div class="container">
            <div class="row">
                <div class="newslist col">

                    <h1 class="page__header">${language("NEWS_NEWS")}</h1>
                    <div class="newslist__info"></div>
                    <div class="newslist__list"></div>
                    <div class="newslist__footer"></div>
                
                </div>
            </div>
        </div>
    `);

}
